import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import EBPropTypes from 'js-utils/prop-types';

import LinkedAccountDialog from '../LinkedAccountsDialog';
import FormSubmitButton from '../FormSubmitButton';
import PasswordField from '../PasswordField';
import StaticEmailField from '../StaticEmailField';

import Button from 'eventbrite_design_system/button/Button';
import { formValidate } from 'eventbrite_design_system/utils/form';
import {
    TYPE_BUTTON,
    STYLE_ANCHOR,
} from 'eventbrite_design_system/button/constants';

import { logInValidate as validate } from '../utils';
import { setWindowLocation } from 'js-utils/http';
import { BASE_URL, LINK_ACCOUNTS_LOG_IN_FORM } from '../../constants';

import CaptchaField from '../CaptchaField';

const ForgotPasswordLink = ({ handleForgotPassword }) => (
    <div className="eds-l-pad-top-2 eds-text--center">
        <Button
            type={TYPE_BUTTON}
            style={STYLE_ANCHOR}
            onClick={handleForgotPassword}
        >
            {gettext('Forgot password')}
        </Button>
    </div>
);

class LinkAccountsLogInForm extends React.PureComponent {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        email: PropTypes.string,
        handleEmailEdit: PropTypes.func,
        buttonCTA: EBPropTypes.translation,
        handleForgotPassword: PropTypes.func,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        linkedAccountSuccessUrl: PropTypes.string,
        showCaptcha: PropTypes.bool,
        recaptcha2PublicKey: PropTypes.string,
        /* Props Provided Via ReduxForm */
        submitFailed: PropTypes.bool,
        submitSucceeded: PropTypes.bool,
        submitting: PropTypes.bool,
        onForceStld: PropTypes.func,
    };

    state = {
        showDialog: false,
    };

    constructor(props) {
        super(props);

        this.dialogTimeout = null;
    }

    componentDidMount() {
        const { onForceStld } = this.props;

        if (onForceStld) {
            onForceStld();
        }
    }

    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const {
            showNotification,
            clearNotification,
            linkedAccountSuccessUrl,
        } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }

        if (linkedAccountSuccessUrl) {
            this.setState({
                showDialog: true,
            });
            this.dialogTimeout = setTimeout(
                () => this._handleCloseDialog(),
                5000,
            );
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    _handleForgotPassword() {
        const { handleForgotPassword, clearNotification } = this.props;

        clearNotification();
        handleForgotPassword();
    }

    _handleCloseDialog = () => {
        const { linkedAccountSuccessUrl } = this.props;
        const redirectUrl = linkedAccountSuccessUrl
            ? linkedAccountSuccessUrl
            : BASE_URL;

        // If user triggered redirect manually, discard auto-redirect
        if (this.dialogTimeout) {
            clearTimeout(this.dialogTimeout);
        }

        this.setState({
            showDialog: false,
        });

        setWindowLocation(redirectUrl);
    };

    render() {
        const {
            handleSubmit,
            email,
            handleEmailEdit,
            submitting,
            submitSucceeded,
            buttonCTA,
            clearNotification,
            submitFailed,
            showCaptcha,
            recaptcha2PublicKey,
        } = this.props;

        const buttonClasses =
            'eds-fx--fade-in-down eds-fx--delay-1 eds-l-mar-top-6';

        const isSubmitDisabled = submitting || submitSucceeded;

        return (
            <div className="eds-fx--fade-in eds-fx--delay-2">
                <LinkedAccountDialog
                    showDialog={this.state.showDialog}
                    onCloseDialog={this._handleCloseDialog}
                />
                <form onSubmit={handleSubmit} noValidate="novalidate">
                    <StaticEmailField
                        email={email}
                        onEmailEdit={handleEmailEdit}
                        clearNotification={clearNotification}
                    />
                    <PasswordField isLogin={true} submitFailed={submitFailed} />
                    <CaptchaField
                        showCaptcha={showCaptcha}
                        recaptcha2PublicKey={recaptcha2PublicKey}
                        submitFailed={submitFailed}
                    />

                    <FormSubmitButton
                        submitDisabled={isSubmitDisabled}
                        buttonClasses={buttonClasses}
                        buttonCTA={buttonCTA}
                    />
                    <ForgotPasswordLink
                        handleForgotPassword={this._handleForgotPassword.bind(
                            this,
                        )}
                    />
                </form>
            </div>
        );
    }
}

export default formValidate({
    validate,
    form: LINK_ACCOUNTS_LOG_IN_FORM,
    touchOnBlur: false,
})(LinkAccountsLogInForm);
